export const OPEN_EDITOR = 'OPEN_EDITOR';
export const CLOSE_EDITOR = 'CLOSE_EDITOR';
export const REWORD_TEXT = 'REWORD_TEXT';
export const SET_TEXT_TO_REWORD = 'SET_TEXT_TO_REWORD';
export const SET_REWORD_PARAMS = 'SET_REWORD_PARAMS';
export const RESET_AI_EDITOR_STATE = 'RESET_AI_EDITOR_STATE';
